"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _HighlightedMerchBizObjectives = _interopRequireDefault(require("self-service-api/constants/HighlightedMerchBizObjectives"));

var _CurrentPlanTag = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CurrentPlanTag"));

var _HighlightedMerchHeaderConfig = _interopRequireDefault(require("pricing-pages-unified-ui/constants/HighlightedMerchHeaderConfig"));

var _MerchCardCTAsContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/MerchCardCTAsContainer"));

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _HighlightedMerchPriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/HighlightedMerchPriceDisplay"));

var _BizObjectives = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/BizObjectives"));

var _ViewAllFeaturesLoadWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/ViewAllFeaturesLoadWrapper"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

var _MerchCardTermSelectorContainer = _interopRequireDefault(require("./MerchCardTermSelectorContainer"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _stateUtils = require("../../utils/stateUtils");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _ItemConfigsSelectors = require("../../selectors/ItemConfigsSelectors");

var _IncludedUnitsSubtext = _interopRequireDefault(require("./merch-card/IncludedUnitsSubtext"));

var _Mon386Stepper = _interopRequireDefault(require("./Mon386Stepper"));

var _Mon386Tagline = _interopRequireDefault(require("./Mon386Tagline"));

var _ExperimentTreatmentSelectors = require("../../selectors/ExperimentTreatmentSelectors");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 90%;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    max-width: initial;\n    width: 90% !important;\n    padding-bottom: 30px !important;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    max-width: initial;\n    width: 80% !important;\n    margin: 20px auto 0 !important;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "HighlightedMerchCard__StyledCardWrapper",
  componentId: "sc-8sukks-0"
})(["border:1px solid ", ";z-index:1;box-shadow:none !important;", " ", ";", ";"], _colors.BATTLESHIP, _responsiveBreakpoints.default.sd(_templateObject()), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()));

var StyledCTAsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HighlightedMerchCard__StyledCTAsWrapper",
  componentId: "sc-8sukks-1"
})(["margin:0 auto;width:80%;text-align:center;button,a{width:100%;line-height:23px;}", ";"], _responsiveBreakpoints.default.tablet(_templateObject4()));

var StyledCTAsContainer = (0, _styledComponents.default)(_MerchCardCTAsContainer.default).withConfig({
  displayName: "HighlightedMerchCard__StyledCTAsContainer",
  componentId: "sc-8sukks-2"
})(["&:not(:empty){margin-bottom:28px;}"]);
var StyledCardSection = (0, _styledComponents.default)(_UICardSection.default).withConfig({
  displayName: "HighlightedMerchCard__StyledCardSection",
  componentId: "sc-8sukks-3"
})(["padding:30px 36px 20px !important;", ";"], _responsiveBreakpoints.default.tablet(_templateObject5()));

var HighlightedMerchCard = function HighlightedMerchCard(_ref) {
  var merchandiseId = _ref.merchandiseId,
      ownsProduct = _ref.ownsProduct,
      hub = _ref.hub,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      availableTerms = _ref.availableTerms;

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      setActiveTerm = _useActiveTerm.setActiveTerm;

  var _useActiveTerm2 = (0, _stateUtils.useActiveTerm)(),
      activeTerm = _useActiveTerm2.activeTerm;

  activeTerm = (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTerms);
  var headerConfig = _HighlightedMerchHeaderConfig.default[merchandiseId];
  var title = headerConfig.title,
      includes = headerConfig.includes,
      icon = headerConfig.icon;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      additionalUnitQuantity = _useState2[0],
      setAdditionalUnitQuantity = _useState2[1];

  var mon386Props = {
    merchandiseId: merchandiseId,
    additionalUnitQuantity: additionalUnitQuantity,
    setAdditionalUnitQuantity: setAdditionalUnitQuantity,
    activeTerm: activeTerm
  };
  var mon386Variant = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon386VariantSelector); // The outer div wrapper is for IE not doing proper width calculation

  return _react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, _react.default.createElement(StyledCardWrapper, {
    "data-selenium-id": merchandiseId + "-merch-card"
  }, ownsProduct && _react.default.createElement(_CurrentPlanTag.default, null), _react.default.createElement(StyledCardSection, null, _react.default.createElement(_UIFlex.default, {
    justify: "between",
    direction: "row",
    align: "end"
  }, _react.default.createElement("div", {
    className: "m-right-1"
  }, _react.default.createElement(_UIImage.default, {
    className: "display-inline",
    src: icon
  }), _react.default.createElement("h2", {
    className: "m-bottom-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: title
  }))), _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [16, 23, 16],
    widths: [60, 70, 130],
    className: "flex-column align-end"
  }, _react.default.createElement(_HighlightedMerchPriceDisplay.default, {
    activeTerm: activeTerm,
    merchandiseId: merchandiseId,
    hub: hub,
    additionalUnitQuantity: additionalUnitQuantity
  }))), includes && _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [24],
    widths: [188],
    className: "m-top-2"
  }, mon386Variant === 'control' && _react.default.createElement(_IncludedUnitsSubtext.default, {
    merchandiseId: merchandiseId,
    className: "m-top-2"
  }), mon386Variant === 'tagline' && _react.default.createElement(_Mon386Tagline.default, mon386Props), mon386Variant === 'stepper' && _react.default.createElement(_Mon386Stepper.default, mon386Props)), _react.default.createElement(_MerchCardTermSelectorContainer.default, {
    activeTerm: activeTerm,
    merchandiseId: merchandiseId,
    onChange: function onChange(term) {
      return setActiveTerm(term);
    }
  })), _react.default.createElement(StyledCTAsWrapper, null, _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [47],
    className: "m-bottom-7"
  }, _react.default.createElement(StyledCTAsContainer, {
    activeTerm: activeTerm,
    merchandiseId: merchandiseId,
    hub: hub,
    additionalUnitQuantity: additionalUnitQuantity
  }))), _react.default.createElement(_BizObjectives.default, {
    merchandiseId: merchandiseId,
    hub: hub,
    inSingleColumnPriceDisplay: true
  }), _react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end',
      height: '100%'
    }
  }, _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [50],
    style: {
      width: '100%'
    }
  }, _react.default.createElement(StyledCardSection, null, _react.default.createElement(_ViewAllFeaturesLoadWrapper.default, {
    hub: hub,
    merchandiseId: merchandiseId
  }))))));
};

HighlightedMerchCard.propTypes = {
  merchandiseId: _propTypes.default.oneOf(Object.keys(_HighlightedMerchBizObjectives.default).map(function (id) {
    return parseInt(id, 10);
  })).isRequired,
  hub: _propTypes.default.string.isRequired,
  ownsProduct: _propTypes.default.bool.isRequired,
  hasPricingAndPurchasingSucceeded: _propTypes.default.bool.isRequired,
  availableTerms: _propTypes.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId;
  return {
    ownsProduct: (0, _ProductOwnershipSelectors.ownsProductSelector)(state, merchandiseId),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    availableTerms: (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HighlightedMerchCard);

exports.default = _default;
module.exports = exports.default;